import { ContactBody } from "../public/contact";

// In-app Contact Us (Platform Owner → Settings → Contact Us).
const ContactPage = () => (
  <div className="dashboard">
    <section className="panel">
      <div className="panel__head">
        <div>
          <h2>Contact Us</h2>
        </div>
      </div>
      <div className="panel__body">
        <ContactBody />
      </div>
    </section>
  </div>
);

export default ContactPage;
